<template>
  <span class="brand" :class="size">
    <img class="brand-logo" :src="src" :alt="`${company.name}（${company.brandEn}）`"/>
  </span>
</template>

<script>
import logo from '@/assets/img/brand/logo-dark.png'
import { company } from '@/data/site'

/**
 * 公司品牌标识：直接使用官方 LOGO 的深色底适配版
 * （文字部分转为白色，H 标记保留品牌渐变；浅底场景用 public/logo.png）
 */
export default {
  name: 'BrandLogo',
  props: {
    size: { type: String, default: 'md' }, // sm | md | lg
    light: { type: Boolean, default: false }
  },
  data() {
    return { src: logo, company }
  }
}
</script>

<style lang="scss" scoped>
.brand {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}

.brand-logo {
  width: auto;
  transition: filter 0.4s, transform 0.4s;
}

.brand:hover .brand-logo {
  filter: drop-shadow(0 0 12px rgba(34, 224, 255, 0.55));
  transform: translateY(-1px);
}

/* 高度控制：LOGO 原始比例 4.53:1 */
.sm .brand-logo { height: 30px; }
.md .brand-logo { height: 40px; }
.lg .brand-logo { height: 52px; }

@media (max-width: 760px) {
  .md .brand-logo { height: 32px; }
  .lg .brand-logo { height: 40px; }
}
</style>
